import { forEach, isEmpty } from "lodash-es";
import humps from "humps";
import search from "./stores/search";
import reservationForm from "./stores/reservationForm";
import profile from "./stores/profile/profile";
import Cookies from "js-cookie";
import {
  API_MINOR_VERSION,
  API_PROVIDER,
  API_MAJOR_VERSION,
  API_BASE_URL
} from "./constant.js";

export default function() {
  const { appConfig } = window;
  const {
    signedInUser,
    minGroupBookingPartySize,
    locale,
    appDescription,
    appTitle
  } = appConfig;
  let user = null;
  if (typeof signedInUser === "object") {
    user = humps.camelizeKeys(signedInUser);
  }

  return {
    modules: {
      search,
      reservationForm,
      profile
    },
    state: {
      user,
      constant: {
        majorVersion: API_MAJOR_VERSION,
        minorVersion: API_MINOR_VERSION,
        provider: API_PROVIDER,
        baseUrl: API_BASE_URL
      },
      token: Cookies.get("hungryhub_access_token"),
      reservation: { adult: 2, kids: 0, date: null, startTime: null },
      config: { minGroupBookingPartySize, locale, appDescription, appTitle },
      appConfig: {},
      style: {
        isFixedBookNow: true,
        isFixedSidebar: false
      }
    },
    getters: {
      isUserSignedIn: state => {
        if (state && state.user !== null) {
          return true;
        }
        return false;
      },
      currentUser: state => {
        if (isEmpty(state.user)) {
          return {};
        }
        return state.user;
      },
      reservationForm: state => {
        if (isEmpty(state.reservation)) {
          return {};
        }
        return state.reservation;
      },
      config: state => {
        if (isEmpty(state.config)) {
          return {};
        }
        return state.config;
      },
      token: state => {
        if (isEmpty(state.token)) {
          return "";
        }
        return state.token;
      },
      constant: state => {
        if (isEmpty(state.constant)) {
          return {};
        }
        return state.constant;
      }
    },
    mutations: {
      updateReservationForm(state, payload) {
        forEach(payload, (value, key) => {
          state.reservation[key] = value;
        });
      },
      toggleBookNowButtonPosition(state, isVisible) {
        state.style.isFixedBookNow = isVisible;
      },
      toggleSidebarBookNow(state, isVisible) {
        state.style.isFixedSidebar = !isVisible;
      }
    },
    actions: {
      updateReservationFormAsync({ commit }, payload) {
        commit("updateReservationForm", payload);
      }
    }
  };
}
